import { EnumType } from './enums';

export const YES = 'Yes';
export const NO = 'No';

export const YES_NO_CONST: readonly EnumType[] = [
  { label: "No", localizedLabel: "forms.no", value: false },
  { label: "Yes", localizedLabel: "forms.yes", value: true },
] as const;

export const COUNSELING_CONST: readonly EnumType[] = [
  { label: "Counseling", localizedLabel: "familyAssistance.counseling", value: 0 },
  { label: "Chaplain", localizedLabel: "familyAssistance.chaplain", value: 1 },
  { label: "Neither", localizedLabel: "familyAssistance.neither", value: 2 },
] as const;

export const NEEDS_CONST: readonly EnumType[] = [
  { label: "Food/Dietary", localizedLabel: "familyAssistance.needs.foodDietary", value: 0 },
  { label: "Transportation", localizedLabel: "familyAssistance.needs.transportation", value: 1 },
  { label: "Short-term Sheltering/Housing", localizedLabel: "familyAssistance.needs.shortTermHousing", value: 2 },
  { label: "Long-term Sheltering/Housing", localizedLabel: "familyAssistance.needs.longTermHousing", value: 3 },
  { label: "Financial", localizedLabel: "familyAssistance.needs.financial", value: 4 },
  { label: "Medications", localizedLabel: "familyAssistance.needs.medications", value: 5 },
  { label: "Animal Care", localizedLabel: "familyAssistance.needs.animalCare", value: 6 },
  { label: "Clothing", localizedLabel: "familyAssistance.needs.clothing", value: 7 },
] as const;

export const FAMILY_COUNT_CONST = Array.from({ length: 10 }, (_, i) => ({
  label: (i + 1).toString() + (i === 9 ? "+" : ""),
  value: i + 1,
}));

export const DISABILITIES_CONST: readonly EnumType[] = [
  { label: "Hearing Aids", localizedLabel: "familyAssistance.disabilities.hearingAids", value: 0 },
  { label: "American Sign Language (ASL)", localizedLabel: "familyAssistance.disabilities.asl", value: 1 },
  { label: "Vision", localizedLabel: "familyAssistance.disabilities.vision", value: 2 },
  { label: "Sensory", localizedLabel: "familyAssistance.disabilities.sensory", value: 3 },
  { label: "Stimulus", localizedLabel: "familyAssistance.disabilities.stimulus", value: 4 },
  { label: "Smell", localizedLabel: "familyAssistance.disabilities.smell", value: 5 },
  { label: "Wheelchair", localizedLabel: "familyAssistance.disabilities.wheelchair", value: 6 },
  { label: "Walker", localizedLabel: "familyAssistance.disabilities.walker", value: 7 },
] as const;

export const FAMILY_ASSISTANCE_ENUMS = {
  YES_NO: [...YES_NO_CONST],
  COUNSELING: [...COUNSELING_CONST],
  NEEDS: [...NEEDS_CONST],
  FAMILY_COUNT: [...FAMILY_COUNT_CONST],
  DISABILITIES: [...DISABILITIES_CONST],
} as const;